import styled from 'styled-components';
import { pxToRem } from '../../../assets/styles/helper';
import themeColors from '../../../assets/styles/themeColors';

// Title styling - made smaller
const ReferralTitle = styled.h2`
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.5px;
  line-height: 1.2;

  @media (min-width: 1200px) {
    font-size: 20px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 1.1;
  }

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

// Subtitle/description - made smaller
const ReferralSubtitle = styled.p`
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
  font-weight: 500;
  margin: 2px 0 0 0;
  opacity: 0.95;
  letter-spacing: 0.3px;

  @media (min-width: 1200px) {
    font-size: 14px;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    margin: 0;
    line-height: 1.2;
  }

  @media (max-width: 480px) {
    font-size: 10px;
  }
`;

const ReferralBannerText = styled.p`
  color: ${themeColors.colorLabel};
  font-size: ${pxToRem(14)};
  line-height: 1.45;
  font-weight: 500;
  margin-bottom: ${pxToRem(14)};
`;

export default { ReferralTitle, ReferralSubtitle, ReferralBannerText };
